import Header from './Header';
import background from './img/softwarePartners.webp';
import MobileNavigation from './MobileNavigation';
import Footer from './Footer';
import { Link } from 'react-router-dom';

const IntegrationsECommerce = () => {
  return (
    <>
      <MobileNavigation />
      <section className="bg-[#212121] woo-commerce">
        <div
          className="w-full pb-28"
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: '200% 200%',
            backgroundPosition: 'bottom center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <Header />
          <div className="p-4 row md:p-8 how">
            <h3 className="text-white large">iQ Pro+ E-Commerce</h3>
          </div>
          <div className="flex p-16 row flex-col justify-center flex-start gap-6 self-stretch rounded-[28px] bg-white !mb-10">
            <h2 className="text-black large">Ecommerce Payments Built for Growth</h2>
            <p className="text-black">Unify your online payment experience with flexible, secure ecommerce solutions.</p>
<p className="text-black">
Our ecommerce integrations are designed to help businesses accept payments seamlessly within their online storefronts and digital platforms. Whether you're selling products, services, subscriptions, or accepting recurring payments, our solutions provide a secure and scalable foundation for modern ecommerce.</p>
<p className="text-black">

Our ecommerce ecosystem supports direct integrations with leading platforms while maintaining a consistent gateway experience across all implementations. </p>
            <h2 className="text-black large">A Complete Ecommerce Payment Solution</h2>
            <p className="text-black">Modern ecommerce requires more than basic payment acceptance. We deliver a comprehensive solution built for performance, security, and flexibility.</p>
<p className="text-black">
Our ecommerce capabilities include:</p>
<ul className="list-disc !ml-8">
<li className='text-black'>Secure iframe-based tokenization to protect sensitive cardholder data</li>
<li className='text-black'>Support for credit, debit, and ACH processing</li>
<li className='text-black'>Recurring billing and subscription management support</li>

<li className='text-black'>Customer payment method vaulting for faster checkout experiences</li>

<li className='text-black'>Hosted fields and embedded payment form options</li>

<li className='text-black'>PCI-compliant architecture designed to reduce your compliance scope</li>

<li className='text-black'>Real-time transaction visibility and reporting</li>

<li className='text-black'>Customer Vaulting</li>

</ul>
<p className="text-black">
Whether you need a simple checkout integration or a fully embedded payment experience, our ecommerce framework adapts to your business model.</p>
<h2 className="text-black large">Flexible Integration Architecture</h2>
<p className='text-black'>Designed to work the way your platform works.</p>

<p className='text-black'>Our ecommerce solutions leverage secure iframe tokenization and hosted payment fields to ensure sensitive payment data never touches your servers. This approach:</p>
<ul className="list-disc !ml-8">
<li className='text-black'>
Reduces PCI burden</li>

<li className='text-black'>

Enhances data security</li>

<li className='text-black'>

Maintains full control over your checkout design and user experience</li>
</ul>
<p className='text-black'>Our iframe tokenizer enables secure card data capture directly within your checkout page, while tokenization allows stored payment methods for subscriptions, repeat purchases, and account-based billing.</p>

<p className='text-black'>For businesses requiring recurring billing, our gateway supports:</p>
<ul className="list-disc !ml-8">
  <li className='text-black'>
Card and ACH recurring transactions
</li>

<li className='text-black'>
Secure card-on-file storage</li>

<li className='text-black'>
Subscription lifecycle management</li>

<li className='text-black'>Automated rebilling workflows</li></ul>

<p className='text-black'>This flexible architecture ensures your ecommerce payment experience remains secure, branded, and scalable as your online presence grows.</p>
<h2 className="text-black large">Supported Plugins</h2>
<ul className="list-disc !ml-8">
  <li className='text-black'>
    <Link to="/integrations-woo-commerce" className="text-blue-600 hover:underline">WooCommerce</Link>
  </li>
  <li className='text-black'>Future plugins to come</li>
</ul>

          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default IntegrationsECommerce;
